/*
 * @Description: 单位管理service
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-30 16:04:12
 * @LastEditTime: 2020-10-29 14:49:08
 * @LastEditors:   YOYO [792611446@qq.com]
 */
import { post, get } from '@/utils/request'

/**
 * 处理childs为空数组时移除
 */
function reduce (list) {
  return list.map(({ childs, ...rest }) => {
    return childs && childs.length
      ? {
        ...rest,
        childs: reduce(childs),
      }
      : { ...rest }
  })
}

/**
 * @description   获取部门列表树
 * @param {*} params
 */
export async function getDepartmentManagementTree (params) {
  const res = await post('/api/json/dept/showAllInfo', params)

  res.data.list = reduce(res.data.list)

  return res
}
/**
 * @description   删除单位管理列表
 * @param {*} params
 */
export async function deleteDepartmentManagement (params) {
  return post('/api/json/dept/deletes', params)
}
/**
 * @description   新增部门
 * @param {*} params
 */
export async function addDepartmentManagement (params) {
  return post('/api/json/dept/addAndUpdate', params)
}
/**
 * @description   获取用户管理列表
 * @param {*} params
 */
export async function getList () {
  const res = await get('/api/hrm/all')
  if (res.code === 'success') {
    res.data.list = res.data.list.map(
      ({ password, sex, loginTime, isValid, openid, mpopenid, ...rest }) => ({
        ...rest,
        sex,
        isValid,
        openid,
        mpopenid,
        sexName: sex === '1' ? '男' : '女',
        isValidName: isValid === '1' ? '可用' : '不可用',
        openidName: openid ? '已绑定' : '未绑定',
        mpopenName: !mpopenid ? '已注销' : '未注销',
      })
    )
  }
  return res
}
